import { Injectable, Type } from '@angular/core';
import { CampaignField } from '@fmnts/api/next';
import {
  DeclarativeFieldBuilder,
  FieldControlState,
  FieldPath,
  FormInputField,
  IDeclarativeFieldComponent,
  isFormInputField,
} from '@fmnts/declarative-forms';
import { UnknownFieldComponent } from '@fmnts/declarative-forms/common';
import {
  CheckboxGroupFieldComponent,
  CheckboxGroupSummaryFieldComponent,
  ComplimentsSelectFieldComponent,
  ComplimentsSelectSummaryFieldComponent,
  RatingFieldComponent,
  RatingSummaryFieldComponent,
  TextBoxFieldComponent,
  TextFieldComponent,
  TextSummaryFieldComponent,
} from '@formunauts/shared/declarative-forms/feature';

function transformDefaultValue(
  value: unknown,
  ctx: { field: FormInputField },
): unknown {
  switch (ctx.field.widget) {
    case 'checkboxes':
      return Array.isArray(value) ? value : [];
    default:
      return value;
  }
}

@Injectable()
export class DeclarativeSupporterFeedbackFormFieldBuilder implements DeclarativeFieldBuilder<CampaignField> {
  resolveFieldComponentType(
    field: CampaignField,
  ): Type<IDeclarativeFieldComponent> {
    switch (field.widget) {
      case 'checkboxes':
        return CheckboxGroupFieldComponent;
      case 'checkboxgroup_summary':
        return CheckboxGroupSummaryFieldComponent;
      case 'checkboxesWithContent':
        return ComplimentsSelectFieldComponent;
      case 'compliments_summary':
        return ComplimentsSelectSummaryFieldComponent;
      case 'starRating':
        return RatingFieldComponent;
      case 'rating_summary':
        return RatingSummaryFieldComponent;
      case 'text':
        return TextFieldComponent;
      case 'text_summary':
        return TextSummaryFieldComponent;
      case 'textbox':
        return TextBoxFieldComponent;
      default:
        return UnknownFieldComponent;
    }
  }

  getInitialFieldControlState<T>(
    field: CampaignField,
    path: FieldPath,
  ): FieldControlState<T> {
    let initialValue = null;

    if (isFormInputField(field)) {
      initialValue = transformDefaultValue(field.widgetOptions.defaultValue, {
        field,
      });
    }

    return {
      options: {},
      state: {
        // The base interface must be prepared to also handle null values
        value: initialValue ?? null,
        disabled: false,
      },
      uiState: {
        dirty: false,
      },
    };
  }

  getFieldStyles(field: CampaignField, path: FieldPath): string {
    return '';
  }
}
